<template>
	<div class="error-index d-flex flex-column justify-center align-center mx-2 text-center">
		<h1 class="text-h1 text-high-emphasis">
			{{ t(`pageError.${errorType}.title`) }}
		</h1>
		<span class="text-subtitle-1 text-medium-emphasis">{{ t(`pageError.${errorType}.message`) }}</span>
	</div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

type ErrorPage = 'notFound' | 'noAccess';

defineProps<{
	errorType: ErrorPage;
}>();
</script>
<style scoped lang="scss">
.error-index {
	height: calc(100% - var(--v-layout-top, 0px));
}
</style>

